import { urlBackoffice } from './backoffice';

/**
 * QA.
 *
 * Lo usa la imagen que buildea el CI en `qa`, con la configuración `qa`
 * (`ANGULAR_CONFIGURATION` en `.gitlab-ci.yml`). Se buildea igual que
 * `development` (sin minificar y con source maps); sólo cambia este archivo.
 * Los comentarios de cada campo están en `environment.ts`.
 */
export const environment = {
  production: false,

  /** El rewrite de `/api` lo hace el vhost de infra. */
  apiUrl: '/api',

  /** Deriva `admin.<dominio>`; el respaldo cubre un host inesperado. */
  backofficeUrl: urlBackoffice('https://admin.qa.phindi.com'),

  /**
   * Key de QA (Maps JavaScript API), restringida por dominio en Google Cloud.
   * Como toda key de la Maps JavaScript API viaja en el bundle; lo que la
   * protege es la restricción, no el secreto.
   */
  googleMapsApiKey: 'AIzaSyDbaN0vQ0qlb_Pt4Zq1ZY_cT-rssSvU8Lk',

  /**
   * Map ID de QA (proyecto de Google Cloud de la key de arriba). Requerido
   * por los AdvancedMarkerElement (pines con precio). El contorno de zona
   * (FE-04) además necesita las capas de nivel 1 y 2 (Área administrativa)
   * habilitadas en su estilo.
   */
  googleMapsMapId: '60d7298563a6e42ee4ef5952',

  /** Contorno de zona en el mapa del buscador (FE-04). */
  contornoDeZonaHabilitado: false,

  /** Búsqueda por provincia en el autocompletado. */
  busquedaPorProvinciaHabilitada: false,
};
